import styled from 'styled-components'
import { Text } from 'components/atoms/Text'
import { Column } from 'components/atoms/Column'
import { SocialLoginButtons } from './SocialLoginButtons'
import { SeparatorWithText } from 'components/molecules/SeparatorWithText'
import { MagicLinkForm } from './MagicLinkForm'
import { EmailLink } from './EmailLink'
import { isFeatureEnabled } from 'utils'

export const LoginForm = () => {
  return (
    <Wrapper>
      <Text variant="title2" color="dark" extraBold>
        Sign in
      </Text>
      <MagicLinkForm />
      {isFeatureEnabled('socialLogin') && (
        <>
          <SeparatorWithText text="or" />
          <SocialLoginButtons />
        </>
      )}
      <SupportText color="light" variant="body3">
        If you have any comments or questions please reach out to <EmailLink email="support@archblock.com" />
      </SupportText>
    </Wrapper>
  )
}

const Wrapper = styled(Column)`
  max-width: 548px;
  gap: 32px;
  align-items: center;
  text-align: center;
  @media ${({ theme }) => theme.queries.largeMobileAndSmaller} {
    padding: 24px 0;
    max-width: 300px;
  }
`
const SupportText = styled(Text)`
  max-width: 300px;
`
